<template>
  <div class="add-to-panel-dailog dialog col-block">
    <!-- <div class="title-container center-block">
      <div class="title">{{ 'Add to Panel'/* ___ */ }}</div>
    </div>
    <div :style="{ height: '30px' }"></div> -->
    <customForm
      :init="panelData"
      :alerts="alerts"
      :forms="formOptions['field1']"
      @change="(result, validate, errors) => formOnChange('field1', result, validate, errors)"
    >
      <template slot="PHENOTYPE_HPO" slot-scope="props">
        <div :id="props.value">{{ param.phenotype.id + ' ' + param.phenotype.name }}</div>
      </template>
    </customForm>
    <div :style="{ height: '7px' }"></div>
    <customForm
      :init="panelData"
      :alerts="alerts"
      :forms="formOptions['field2']"
      @change="(result, validate, errors) => formOnChange('field2', result, validate, errors)"
    ></customForm>
    <div :style="{ height: '15px' }"></div>
    <div class="row-block" :style="{ padding: '0 10px', 'box-sizing': 'border-box' }">
      <div :style="{ flex: 1, height: '1px', background: '#003679' }"></div>
      <div :style="{ width: '20px' }"></div>
      <div :style="{ 'color': '#003679', 'font-size': '1rem', 'font-weight': 'bold' }">{{ 'OR'/* ___ */ }}</div>
      <div :style="{ width: '20px' }"></div>
      <div :style="{ flex: 1, height: '1px', background: '#003679' }"></div>
    </div>
    <div :style="{ height: '15px' }"></div>
    <customForm
      :init="panelData"
      :alerts="alerts"
      :forms="formOptions['field3']"
      @change="(result, validate, errors) => formOnChange('field3', result, validate, errors)"
    ></customForm>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Cancel'/* ___ */ }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => !onSubmit ? validateAddToPanel() : ''">
        <span>{{ 'Add'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { postPhenotypePanel, postAddToPhenotypePanel } from '../../api'
import customForm from '../../components/tool/customForm'
import toastMethods from '../../mixins/toastMethods'

export default {
  components: {
    customForm
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      panelData: {
        selectedPanelID: '',
        newPanelName: ''
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    }
  },
  computed: {
    onError () {
      return Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
    },
    selectedPhenotypePanel () {
      return this.param.panels.find(panel => panel.id === this.result.selectedPanelID)
    },
    // static
    formOptions () {
      return {
        field1: [
          {
            title: 'Phenotype'/* ___ */,
            value: 'PHENOTYPE_HPO'
          }
        ],
        field2: [
          {
            title: 'Select a Panel'/* ___ */,
            value: 'selectedPanelID',
            type: 'select',
            options: this.param.panels.filter(panel => !panel.phenotypes.some(phenotype => phenotype.id === this.param.phenotype.id)).map(panel => ({ title: panel.panel, value: panel.id })),
            placeholder: () => 'Please Select a Panel you need'/* ___ */
          }
        ],
        field3: [
          {
            title: 'Add to new panel'/* ___ */,
            value: 'newPanelName',
            type: 'input',
            placeholder: () => 'Please create a new panel name'/* ___ */
          }
        ]
      }
    }
  },
  watch: {
    'result.selectedPanelID' () {
      this.customValidate([], ['newPanelName'])
    },
    'result.newPanelName' () {
      this.customValidate([], ['newPanelName'])
    }
  },
  methods: {
    formOnChange (field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result = {
        ...this.result,
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
        newPanelName: value => {
          if (!value && !this.result.selectedPanelID) {
            return {
              type: 'error',
              msg: 'New panel name should not be empty.'/* ___ */
            }
          }
        }
      }
      for (let col of cols || Object.keys(this.panelData)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    async validateAddToPanel () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['custom'] = this.customValidate()
      if (!Object.values(result).includes(false)) {
        if (!this.selectedPhenotypePanel || !this.selectedPhenotypePanel.phenotypes.some(phenotype => phenotype.id === this.param.phenotype.id)) {
          await this.addToPanel()
        } else {
          this.addToast('error', 'You have added a HPO term with the same HPO identity.'/* ___ */)
        }
      }
      this.onSubmit = false
    },
    async addToPanel () {
      try {
        let config = this.$ls.get('userInfo')
        let phenotypeID = this.param.phenotype.id
        let type = this.param.phenotype.type
        let idType = {
          hpo: 'hpo_id',
          disease_term: 'disease_id'
        }[type]
        let id = this.result.selectedPanelID
        let panelName = this.result.newPanelName
        let response = panelName ? await postPhenotypePanel({ panel: panelName, [idType + 's']: [phenotypeID] }, config) : await postAddToPhenotypePanel(id, type, { [idType]: phenotypeID }, config)
        this.addToast('success', response.data.result.message)
        let newPanel = response.data.data
        this.$emit('changeModal', {}, newPanel)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/addToPanel.vue